import { render, staticRenderFns } from "./contact-page.vue?vue&type=template&id=40a3c0eb&scoped=true"
import script from "./contact-page.vue?vue&type=script&lang=js"
export * from "./contact-page.vue?vue&type=script&lang=js"
import style0 from "./contact-page.vue?vue&type=style&index=0&id=40a3c0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3c0eb",
  null
  
)

export default component.exports